const C = {
  name: "CurrencyDollar",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 10C7 8.34772 8.34772 7 10 7H11V5H13V7H14C15.6523 7 17 8.34772 17 10H15C15 9.45228 14.5477 9 14 9H13V11H14C15.6523 11 17 12.3477 17 14C17 15.6523 15.6523 17 14 17H13V19H11V17H10C8.34772 17 7 15.6523 7 14H9C9 14.5477 9.45228 15 10 15H11V13H10C8.34772 13 7 11.6523 7 10ZM11 11V9H10C9.45228 9 9 9.45228 9 10C9 10.5477 9.45228 11 10 11H11ZM13 13V15H14C14.5477 15 15 14.5477 15 14C15 13.4523 14.5477 13 14 13H13Z" fill="currentColor"/>
<path d="M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as CurrencyDollar
};
